import { supabase } from "../../supabaseClient"

export const getAllCourses = async () => {
    return await supabase
        .from('Course')
        .select("*")
}